import React, { useCallback, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { CommonSelect, CommonToolTip, CstmPagination } from "components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { MANAGE_SUPPORT_STAFF_ADD, MANAGE_SUPPORT_STAFF_EDIT, MANAGE_TEACHERS_ADD, MANAGE_TEACHERS_EDIT } from "config/paths";
import { dateFormat, dateTimeFormat, successMessageToast } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { ArchiveIcon, ChatIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import TableLayout from "components/TableLayout";
import ErrorComponent from "components/shared/ErrorComponent";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDeleteSupportStaffMutation, useGetSupportStaffListQuery, useResendStaffAccountActivationMutation } from "store/services/supportStaff";
import { useArchiveSupportStaffMutation } from "store/services/archive";
import AlertPop from "components/Modals/AlertPop";
import { useDispatch, useSelector } from "react-redux";
import { supportStaffFilter } from "store/slices/filter";
import { STAFF_TYPE_OPTIONS, staffStatusOptions, THERAPIST_STATUS_OPTIONS } from "config/constants";
import TableLayoutV2 from "components/TableLayoutV2";
import { RightArrowIcon, ThreeDotsMenuIcon } from "Assets/icons/V2";
import { debounce } from "lodash";
import dummyUserImage from "Assets/images/dummy_user.jpg";
import { useSchoolLookupQuery } from "store/services/utility";
import { useSchoolDivisonLookupQuery } from "store/services/schoolsDivisons";

const ManageSupportStaff = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.supportStaffFilter);

    const [modalType, setModalType] = useState(null);
    /*modal */
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [supportStaffList, setSupportStaffList] = useState([]);
    const [showAlertModal, setShowAlertModal] = useState(false);

    const [archiveStaff, { isLoading: archiveStaffLoading }] = useArchiveSupportStaffMutation();
    const [deleteStaff, { isLoading: deleteStaffLoading }] = useDeleteSupportStaffMutation();
    const [resendAccountActivation, { isLoading: resendAccountActivationLoading }] = useResendStaffAccountActivationMutation();
    const { data: schoolDivisionsList, isLoading: schoolDivisionsListLoading } = useSchoolDivisonLookupQuery();

    const { data: schoolList, isLoading: schoolListLoading, isFetching: schoolListFetching } = useSchoolLookupQuery();
    const schoolListOptions = schoolList?.map((i) => ({ value: i.id, label: i.name }));

    const { data, isLoading, isError, isFetching, refetch } = useGetSupportStaffListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const handleDelete = async () => {

        try {

            setShowModal(false);

            const list = [...supportStaffList];
            const index = supportStaffList?.findIndex(x => x.id === currentEntry?.id);
            delete list[index];
            setSupportStaffList(list.filter(Boolean));

            const result = await deleteStaff(currentEntry?.id);
            if (!result?.error) successMessageToast(result?.data?.message);

        } catch (err) { console.error("error deleting parent", err); };
    };

    const handleArchive = async () => {

        try {

            setShowModal(false);

            const list = [...supportStaffList];
            const index = supportStaffList?.findIndex(x => x.id === currentEntry?.id);
            list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
            setSupportStaffList(list.filter(Boolean));

            const result = await archiveStaff(currentEntry?.id);
            refetch();
            if (!result?.error) successMessageToast("Record has been updated successfully.");

        } catch (err) { console.error("error archiving parent", err); };
    };

    const handleResendMail = async () => {
        try {

            setShowModal(false);

            let result = await resendAccountActivation(currentEntry?.id);
            if (!result.error) {
                successMessageToast("Account activation mail has been sent successfully.");
            }
        } catch (err) {
            console.error("error resend activation mail", err);
        }
    };

    const column = [
        {
            head: "LAST NAME",
            accessor: "lastname",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <div className="d-flex align-items-center gap-10">
                    <div className="imgWrp flex-shrink-0">
                        <img
                            src={item?.staffDetail?.profile_picture || dummyUserImage}
                            alt=""
                            className="img-fluid rounded-circle object-fit-cover"
                            style={{ height: 35, width: 35 }}
                        />
                    </div>
                    <h6 className="m-0 fw-sbold">
                        <Link
                            className="text-dark"
                        // to={generatePath(THERAPIST_DETAIL, { id: item.id })}
                        >
                            {item.lastname}
                        </Link>
                    </h6>
                </div>
            ),
            // component: (item, ind) => (
            //     <h6 className="m-0 fw-bold themeBlue">{item?.lastname || "--"}</h6>
            // ),
        },
        {
            head: "FIRST NAME",
            accessor: "firstname",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.firstname || "--"}</h6>
            ),
        },
        {
            head: "Date Created",
            accessor: "createdAt",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">
                    {dateFormat(item?.createdAt, "MMM DD, YYYY")}
                </h6>
            ),
        },

        {
            head: "Staff Type",
            accessor: "client_type",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">
                    {item?.staffDetail?.client_type == 'home_education' ? "Home Education" : "School"}
                </h6>
            ),
        },
        // {
        //     head: "",
        //     accessor: "email",
        //     isComponent: true,
        //     sorter: false,
        //     component: (item, ind) => (
        //         <p className="cell-text-ellipsis">{item?.email || "--"}</p>
        //     ),
        // },
        {
            head: "SCHOOL",
            accessor: "school_support_staff",
            sorter: true,
            component: (item, ind) => {
                const schoolList = item?.school_support_staff || [];
                const tooltipContent = schoolList.length ? (
                    <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                        {schoolList.map((s, i) => (
                            <li
                                key={i}
                                style={{ position: "relative", paddingLeft: "10px", marginBottom: "2px", textAlign: "left" }}>
                                <span style={{ position: "absolute", left: 0, top: 0 }}>•</span>
                                {s?.schools?.name}
                            </li>
                        ))}
                    </ul>

                ) : (
                    "NA"
                );

                const firstSchool = schoolList?.[0]?.schools?.name;

                const displayText = firstSchool ? (
                    schoolList.length > 1 ? (
                        <>
                            {firstSchool}...+<span>{schoolList.length - 1}</span>
                        </>
                    ) : (
                        firstSchool
                    )
                ) : (
                    "NA"
                );


                return (
                    <CommonToolTip
                        text={tooltipContent}
                        component={<p>{displayText}</p>}
                    />
                );
            },
        },
        {
            head: "STATUS",
            accessor: "status",
            sorter: true,
            isComponent: true,
            // component: (item, ind) => (
            //     <p
            //         style={{ width: 80 }}
            //         className={`${item.status == "active"
            //             ? "greenStatus"
            //             : "redStatus"
            //             } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
            //     >
            //         {item.status}
            //     </p>
            // ),
            component: (item, ind) => (
                <div>
                    <p
                        style={{ width: 80, fontStyle: item?.status != "active" && "italic" }}
                        className={`${item.status == "active"
                            && "greenStatus"
                            // : "redStatus"
                            } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-2 py-1`}
                    >
                        {item.status}
                    </p>
                </div>
            ),
        },
        {
            head: "",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex justify-content-between align-items-center  gap-10">
                    <Dropdown
                        onClick={(e) => e.stopPropagation()}
                    // show={index == dropdownIndex}
                    // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <ThreeDotsMenuIcon />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                <h5 onClick={(e) => {

                                    e.stopPropagation();
                                    navigate(MANAGE_SUPPORT_STAFF_EDIT.replace(":id", item.id));
                                }} className="cursor-pointer proxima mb-2">
                                    Edit
                                </h5>
                                <h5 onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentEntry(item);
                                    setModalType(item?.status == "active" ? "archive" : "active");
                                    setShowModal(true);
                                }} className="cursor-pointer proxima mb-2">
                                    {item?.status == "active" ? "Archive" : "Unarchive"}
                                </h5>
                                <h5 onClick={(e) => {
                                    e.stopPropagation()

                                    if (item?.email_verified_at) {

                                        setShowAlertModal(true);
                                        return;
                                    };
                                    setModalType("resendAccountActivationMail")
                                    setCurrentEntry(item);
                                    setShowModal(true);
                                }} className="cursor-pointer proxima mb-2">
                                    Resend Invite to User
                                </h5>
                                {/* <h5 onClick={(e) => {
                                    e.stopPropagation()
                                    if (item?.id) {
                                        navigate(`/manage-support-staff/details/${item?.id}`)
                                    };
                                }} className="cursor-pointer proxima mb-2">
                                    Manager User
                                </h5> */}
                                <h5 onClick={(e) => {

                                    e.stopPropagation();
                                    setCurrentEntry(item);
                                    setModalType("delete");
                                    setShowModal(true);
                                }}
                                    className="cursor-pointer proxima mb-2">
                                    Delete
                                </h5>
                            </ul>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <RightArrowIcon />
                        </Dropdown.Toggle>

                    </Dropdown>

                    {
                        item?.status == "complete" && <div
                            className="cursor-pointer d-flex align-items-center"
                            style={{ padding: "10px 10px" }}
                            onClick={(e) => {
                                e.stopPropagation(); // prevent row navigation
                                toggleRow(item.id);
                            }}
                        >
                            {openRow === item.id ? (
                                <img width={12} src={downArrow} alt="Collapse" />
                            ) : (
                                <img width={7} src={rightArrow} alt="Expand" />
                            )}
                        </div>
                    }
                </div >

            ),
        },
        // {
        //     head: "Action",
        //     accessor: "",
        //     isComponent: true,
        //     component: (item) => (
        //         <div className="ActnBtn d-flex align-items-center  gap-10">
        //             <CommonToolTip
        //                 text={"Edit"}
        //                 component={<Button
        //                     className="p-0"
        //                     variant="transparent"
        //                     type="button"
        //                     onClick={(e) => {

        //                         e.stopPropagation();
        //                         navigate(MANAGE_SUPPORT_STAFF_EDIT.replace(":id", item.id));
        //                     }}
        //                 >
        //                     <EditIcon />
        //                 </Button>}
        //             />
        //             <CommonToolTip
        //                 text={item?.status == "active" ? "Archive" : "Unarchive"}
        //                 component={<Button
        //                     onClick={(e) => {

        //                         e.stopPropagation();
        //                         setCurrentEntry(item);
        //                         setModalType(item?.status == "active" ? "archive" : "active");
        //                         setShowModal(true);
        //                     }}
        //                     className="p-0"
        //                     variant="transparent"
        //                     type="button"
        //                 >
        //                     {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
        //                 </Button>}
        //             />
        //             <CommonToolTip
        //                 text={"Resend Mail"}
        //                 component={<Button
        //                     className="p-0"
        //                     variant="transparent"
        //                     type="button"
        //                     onClick={(e) => {
        //                         e.stopPropagation()

        //                         if (item?.email_verified_at) {

        //                             setShowAlertModal(true);
        //                             return;
        //                         };
        //                         setModalType("resendAccountActivationMail")
        //                         setCurrentEntry(item);
        //                         setShowModal(true);
        //                     }}
        //                 >
        //                     <ChatIcon />
        //                 </Button>}
        //             />
        //             <CommonToolTip
        //                 text={"Delete"}
        //                 component={<Button
        //                     className="p-0"
        //                     variant="transparent"
        //                     type="button"
        //                     onClick={(e) => {

        //                         e.stopPropagation();
        //                         setCurrentEntry(item);
        //                         setModalType("delete");
        //                         setShowModal(true);
        //                     }}
        //                 >
        //                     <DeleteIcon />
        //                 </Button>}
        //             />
        //         </div>
        //     ),
        // },
    ]

    const handleFilterChange = (key) => (value) => {
        dispatch(supportStaffFilter({ ...filter, [key]: value }))
        setCurrentPage(1);
    }

    const handleSearchChange = useCallback(debounce((value) => {
        setCurrentPage(1);
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const resetFilter = () => {
        dispatch(supportStaffFilter({ search: "", status: "active", sort: { column: "id", direction: "desc" } }));
        setCurrentPage(1)
    };

    useLayoutEffect(() => {

        if (data?.records) setSupportStaffList(data?.records)
    }, [data]);

    return (
        <>
            <AlertPop
                confirmation={showAlertModal}
                setConfirmation={setShowAlertModal}
                message={"The account has been already verified"}
            />

            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "delete" ? handleDelete : modalType == "resendAccountActivationMail" ? handleResendMail : handleArchive}
                type={modalType}
            />
            <section className="ManageDiscriplines position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">

                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="clinican-head">
                                    <div className="left classroom-conslutation">
                                        <h6 className="m-0 fw-bold main-head themeBlue">Support Staff</h6>
                                    </div>

                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link to={MANAGE_SUPPORT_STAFF_ADD} className="blue-discharge-screen-btn-new mt-0 d-flex align-items-center justify-content-center">
                                                Add Support Staff
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <Row className="d-flex justify-content-end mt-4">
                                <Col md="3">
                                    <div className="w-100  align-items-center gap-2 reports-v2 classroom-conslutation">
                                        <label className="discharge-screen-label mb-0">Division</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={
                                                schoolDivisionsList?.length && schoolDivisionsList?.map(item => ({
                                                    value: item.id,
                                                    label: item.title,
                                                }))
                                            }
                                            onChange={(e) => handleFilterChange("division")(e)}
                                            value={filter?.division}
                                            isClearable={true}
                                            isFilterV2
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col md="3">
                                    <div className="w-100  align-items-center gap-2 reports-v2 classroom-conslutation">
                                        <label className="discharge-screen-label mb-0">School</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={schoolListOptions}
                                            onChange={(e) => handleFilterChange("school")(e)}
                                            value={filter?.school}
                                            isClearable={true}
                                            isFilterV2

                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>

                                <Col md="2">
                                    <div className="w-100 align-items-center gap-2 reports-v2 classroom-conslutation">
                                        <label className="discharge-screen-label mb-0">Staff Type</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={STAFF_TYPE_OPTIONS}
                                            onChange={(e) => handleFilterChange("client_type")(e)}
                                            value={filter?.client_type}
                                            isFilterV2
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>

                                <Col lg="2">
                                    <div className="w-100 align-items-center gap-2 reports-v2 classroom-conslutation">
                                        <label className="discharge-screen-label mb-0">Status</label>
                                        <CommonSelect
                                            placeholder={"Select"}
                                            option={THERAPIST_STATUS_OPTIONS}
                                            onChange={(e) => handleFilterChange("status")(e)}
                                            value={filter?.status}
                                            isFilterV2
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: "100%",
                                                }),
                                            }}
                                        />
                                    </div>
                                </Col>

                                <Col lg="2" style={{ borderLeft: "1px solid #315D99" }}>
                                    <div className="w-100 align-items-center gap-2 reports-v2 classroom-conslutation">
                                        <label className="discharge-screen-label mb-0">Search</label>
                                        <input
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            // style={{outline: "blue"}}
                                            className={`input-new readonly-box h-auto search-input-filter-v2`}
                                            placeholder="Find a staff..."
                                            defaultValue={filter?.search}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="my-2">
                            {/* <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <TableHeader
                                        heading={"Support Staff Profiles"}
                                        handleFilterChange={handleFilterChange}
                                        resetFilter={resetFilter}
                                        filter={filter}
                                        statusOptions={staffStatusOptions}
                                        searchPlaceholder="Email, First, Last Name"
                                    />
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link
                                                to={MANAGE_SUPPORT_STAFF_ADD}
                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                            >
                                                <span className="icn me-1">
                                                    <svg
                                                        xmlns="http://www.w3.orGetStaffAssociatedClientstListg/2000/svg"
                                                        width="19"
                                                        height="19"
                                                        viewBox="0 0 19 19"
                                                        fill="none"
                                                    >
                                                        <mask
                                                            id="mask0_0_4440"
                                                            style={{ maskType: "alpha" }}
                                                            maskUnits="userSpaceOnUse"
                                                            x="0"
                                                            y="0"
                                                            width="19"
                                                            height="19"
                                                        >
                                                            <rect
                                                                width="18.7197"
                                                                height="18.7197"
                                                                fill="#D9D9D9"
                                                            />
                                                        </mask>
                                                        <g mask="url(#mask0_0_4440)">
                                                            <path
                                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                    </svg>


                                                </span>{" "}
                                                Add Support Staff
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="table-outer">
                                {isLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || deleteStaffLoading || archiveStaffLoading || resendAccountActivationLoading) && (
                                            <LoadingOverlay />
                                        )}
                                        <TableLayoutV2
                                            data={supportStaffList}
                                            column={column}
                                            url={"/manage-support-staff/details"}
                                            filter={filter}
                                            handleSort={handleFilterChange("sort")}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                    className="paginationV2"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageSupportStaff;
